import { TableCell, ListItemText } from '@mui/material';

import { fDate, fTime } from 'src/utils/format-time';

const DateTimeCell: React.FC<{ created: Date }> = ({ created }) => (
  <TableCell>
    <ListItemText
      primary={fDate(created, undefined, true)}
      secondary={fTime(created, undefined, true)}
    />
  </TableCell>
);

export default DateTimeCell;
